import AxiosConfig from '../../../config/AxiosConfig';

const useConfirmSavDraft = () => {
  const confirmSavDraft = async (id, data) => {
    try {
      const response = await AxiosConfig.create(
        'put',
        `/savdraft/${id}/confirm`
      )
        .call(data)
        .getResponseData();

      return response;
    } catch (err) {
      console.error('Failed to confirm SAV draft:', err);
      throw new Error(`confirmSavDraft failed: ${err?.message}`);
    }
  };

  return {
    confirmSavDraft,
  };
};

export default useConfirmSavDraft;
